import React, { useState, useEffect, forwardRef } from 'react';

//komponen
import { withStyles } from '@mui/styles';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Fab from '@mui/material/Fab';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import InputAdornment from '@mui/material/InputAdornment';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';

//gambar
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PrintIcon from '@mui/icons-material/Print';
import SearchOutlined from '@mui/icons-material/SearchOutlined';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgba(108,122,224,255)",
        borderColor: "rgba(108,122,224,255)",
        color: "white"
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: "rgba(248,246,255,255)",
            borderColor: "rgba(248,246,255,255)"
        },
    },
}))(TableRow);

function Piutang(props, ref) {
    //state
    const [tampil_notif, setTampilNotif] = useState(false);
    const [jenis_notif, setJenisNotif] = useState("success");
    const [isi_notif, setIsiNotif] = useState("");
    const [data_pesanan, setDataPesanan] = useState([]);
    const [data_metode_bayar, setDataMetodeBayar] = useState([]);
    const [id_pembayaran, setIdPembayaran] = useState("");
    const [nama, setNama] = useState("");
    const [metode, setMetode] = useState("D");
    const [no_meja, setNoMeja] = useState("");
    const [hutang_awal, setHutangAwal] = useState(0);
    const [angsuran, setAngsuran] = useState(0);
    const [pelayan, setPelayan] = useState("");
    const [kasir, setKasir] = useState("");
    const [waktu_pembayaran, setWaktuPembayaran] = useState("");
    const [data_angsuran, setDataAngsuran] = useState([]);
    const [data_input_pesanan, setDataInputPesanan] = useState([]);
    const [total, setTotal] = useState(0);
    const [data_jenis, setDataJenis] = useState([]);
    const [jenis, setJenis] = useState("");
    const [data_produk, setDataProduk] = useState([]);
    const [jumlah_metode_bayar, setJumlahMetodeBayar] = useState("M1");
    const [metode_bayar, setMetodeBayar] = useState("M1");
    const [metode_bayar2, setMetodeBayar2] = useState("");
    const [tambah_jual, setTambahJual] = useState(0);
    const [no_telpon, setNoTelpon] = useState("");
    const [dp, setDp] = useState(0);
    const [jumlah_bayar, setJumlahBayar] = useState(0);
    const [jumlah_bayar2, setJumlahBayar2] = useState(0);
    const [metode_diskon, setMetodeDiskon] = useState("nominal");
    const [diskon_persen, setDiskonPersen] = useState(0);
    const [diskon, setDiskon] = useState(0);
    const [kembalian, setKembalian] = useState(0);
    const [id_bayar, setIdBayar] = useState("");
    const [tampil_dialog, setTampilDialog] = useState(false);
    const [tampil_dialog_produk, setTampilDialogProduk] = useState(false);
    const [tampil_dialog_bayar, setTampilDialogBayar] = useState(false);

    const [pencarian, setPencarian] = useState("");
    const [jumlah_baris] = useState(20);
    const [jumlah_halaman, setJumlahHalaman] = useState(0);
    const [halaman, setHalaman] = useState(1);

    //fungsi
    useEffect(() => {
        fetch(props.aplikasi + '/kasir/tampil_piutang.php',
            {
                method: 'GET',
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataPesanan(data.data);
                }
                else {
                    setDataPesanan([]);
                }
            })
            .catch(error => {
                setDataPesanan([]);
            }
            );

        fetch(props.aplikasi + '/metode_bayar/tampil_metode_bayar.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        status: "ada"
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataMetodeBayar(data.data);
                }
                else {
                    setDataMetodeBayar([]);
                }
            })
            .catch(error => {
                setDataMetodeBayar([]);
            }
            );

        setInterval(() => {
            fetch(props.aplikasi + '/kasir/tampil_piutang.php',
                {
                    method: 'GET',
                    headers:
                    {
                        "Content-type": "application/json; charset=UTF-8"
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.kode === 1) {
                        setDataPesanan(data.data);
                    }
                    else {
                        setDataPesanan([]);
                    }
                })
                .catch(error => {
                    setDataPesanan([]);
                }
                );
        }, 10000)

    }, [props.aplikasi]);

    const format_rupiah = (angka) => {
        return (
            angka
                .toFixed(0)
                .replace(".", ",")
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
        )
    }

    const tutup_notif = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setTampilNotif(false);
    };

    const tampil_pesanan = () => {
        fetch(props.aplikasi + '/kasir/tampil_piutang.php',
            {
                method: 'GET',
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataPesanan(data.data);
                    let awal = 1;
                    let akhir = data.data.length;
                    while (awal <= akhir){
                        if (data.data[awal-1].id_pembayaran === id_pembayaran){
                            setAngsuran(data.data[awal-1].angsuran);
                            break;
                        }
                        awal++;
                    }                    
                }
                else {
                    setDataPesanan([]);
                }
            })
            .catch(error => {
                setDataPesanan([]);
            }
            );
    }

    const tampil_pesanan_detail = (id_pembayaran) => {
        fetch(props.aplikasi + '/kasir/tampil_pesanan_detail.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_pembayaran: id_pembayaran
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataInputPesanan(data.data);

                    var tampung = data.data;
                    var tampung_total = 0;
                    var awal = 1;
                    var akhir = tampung.length;
                    while (awal <= akhir) {
                        tampung_total = tampung_total + parseFloat(tampung[awal - 1]["subtotal"]);
                        awal++;
                    }

                    setTotal(tampung_total);
                }
                else {
                    setDataInputPesanan([]);
                    setTotal(0);
                }
            })
            .catch(error => {
                setDataInputPesanan([]);
                setTotal(0);
            }
            );
    }

    const ubah_no_telpon = (event) => {
        const re = /^[0-9\b]+$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }

        setNoTelpon(event.target.value);
    }

    const switch_metode = (param) => {
        switch (param) {
            case "D":
                return "Dine-In";
            case "T":
                return "Take Away";
            default:
                break;
        }
    }

    const switch_warna_metode = (param) => {
        switch (param) {
            case "D":
                return "#e3855f";
            case "T":
                return "#de88e0";
            default:
                break;
        }
    }

    const tampil_jenis = () => {
        return new Promise((resolve) => {
            fetch(props.aplikasi + '/jenis_produk/tampil_jenis_produk.php',
                {
                    method: 'POST',
                    body: JSON.stringify
                        ({
                            status: "1"
                        }),
                    headers:
                    {
                        "Content-type": "application/json; charset=UTF-8"
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.kode === 1) {
                        resolve(data.data);
                    }
                    else {
                        resolve([]);
                    }
                })
                .catch(error => {
                    resolve([]);
                }
                );
        });
    }

    // const tampil_produk = (id_jenis) => {
    //     return new Promise((resolve) => {
    //         fetch(props.aplikasi + '/produk/tampil_produk.php',
    //             {
    //                 method: 'POST',
    //                 body: JSON.stringify
    //                     ({
    //                         status: "1"
    //                     }),
    //                 headers:
    //                 {
    //                     "Content-type": "application/json; charset=UTF-8"
    //                 }
    //             })
    //             .then(response => response.json())
    //             .then(data => {
    //                 if (data.kode === 1) {
    //                     if (id_jenis !== "" && id_jenis !== null) {
    //                         var awal = 1;
    //                         var akhir = data.data.length;

    //                         var tampung = [];
    //                         while (awal <= akhir) {
    //                             if (data.data[awal - 1]["id_jenis"] === id_jenis) {
    //                                 tampung.push(data.data[awal - 1]);
    //                             }
    //                             awal++;
    //                         }

    //                         resolve(tampung);
    //                         return;
    //                     }
    //                     resolve(data.data);
    //                 }
    //                 else {
    //                     resolve([]);
    //                 }
    //             })
    //             .catch(error => {
    //                 resolve([]);
    //             }
    //             );
    //     });
    // }

    const tampil_produk = (id_jenis, halaman_baru) => {
        return new Promise((resolve) => {
            fetch(props.aplikasi + '/produk/tampil_produk_limit.php',
                {
                    method: 'POST',
                    body: JSON.stringify
                        ({
                            status: "1",
                            jenis: id_jenis,
                            cari: pencarian,
                            jumlah_baris: jumlah_baris,
                            halaman: halaman_baru
                        }),
                    headers:
                    {
                        "Content-type": "application/json; charset=UTF-8"
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.kode === 1) {
                        if (id_jenis !== "" && id_jenis !== null) {
                            setJumlahHalaman(Math.ceil(data.jumlah_data / jumlah_baris));
                            resolve(data.data);
                            return;
                        }
                        resolve(data.data);
                    }
                    else {
                        resolve([]);
                    }
                })
                .catch(error => {
                    resolve([]);
                }
                );
        });
    }

    // const cari = (event) => {
    //     var cari = (event.target.value).toLowerCase();
    //     var awal = 1;
    //     var akhir = sumber_produk.length;

    //     var posisi = 0;
    //     var tampung = [];
    //     while (awal <= akhir) {
    //         var hasil = ((sumber_produk[awal - 1]["nama"]).toLowerCase()).indexOf(cari);
    //         if (hasil === -1) {
    //             hasil = ((sumber_produk[awal - 1]["nama"]).toLowerCase()).indexOf(cari);
    //         }

    //         if (hasil !== -1) {
    //             tampung[posisi] = sumber_produk[awal - 1];
    //             posisi++;
    //         }
    //         awal++;
    //     }

    //     setDataProduk(tampung);
    // }

    const cari = async () => {
        setHalaman(1);
        const proses_produk = await tampil_produk(jenis, 1);
        setDataProduk(proses_produk);
    }

    const pindah_halaman = async (halaman_baru) => {
        setHalaman(halaman_baru);
        const proses_produk = await tampil_produk(jenis, halaman_baru);
        setDataProduk(proses_produk);
    }

    const ubah_jenis_produk = async (id_jenis) => {
        setJenis(id_jenis);
        setHalaman(1);
        const proses_produk = await tampil_produk(id_jenis, 1);
        setDataProduk(proses_produk);
    }

    const tambah_pesanan = (id_produk) => {
        var tampung = data_input_pesanan;
        var awal = 1;
        var akhir = tampung.length;
        while (awal <= akhir) {
            if (tampung[awal - 1]["id_produk"] === id_produk) {
                tampung[awal - 1]["jumlah"] = parseInt(tampung[awal - 1]["jumlah"]) + 1;
                tampung[awal - 1]["subtotal"] = parseInt(tampung[awal - 1]["jumlah"]) * parseInt(tampung[awal - 1]["harga"]);
                tampung[awal - 1]["subtotal2"] = format_rupiah(tampung[awal - 1]["subtotal"]);
                break;
            }
            awal++;
        }

        var tampung_total = 0;
        awal = 1;
        akhir = tampung.length;
        while (awal <= akhir) {
            tampung_total = tampung_total + parseFloat(tampung[awal - 1]["subtotal"]);
            awal++;
        }

        setDataInputPesanan(tampung);
        setTotal(tampung_total);
    }

    const kurang_pesanan = (id_produk, jumlah_minimal) => {
        var tampung = data_input_pesanan;
        var awal = 1;
        var akhir = tampung.length;
        while (awal <= akhir) {
            if (tampung[awal - 1]["id_produk"] === id_produk) {
                if (parseInt(tampung[awal - 1]["jumlah"]) - 1 < 1) {
                    return;
                }

                if (parseInt(tampung[awal - 1]["jumlah"]) - 1 < parseInt(jumlah_minimal)) {
                    return;
                }
                tampung[awal - 1]["jumlah"] = parseInt(tampung[awal - 1]["jumlah"]) - 1;
                tampung[awal - 1]["subtotal"] = parseInt(tampung[awal - 1]["jumlah"]) * parseInt(tampung[awal - 1]["harga"]);
                tampung[awal - 1]["subtotal2"] = format_rupiah(parseInt(tampung[awal - 1]["subtotal"]));
                break;
            }
            awal++;
        }

        var tampung_total = 0;
        awal = 1;
        akhir = tampung.length;
        while (awal <= akhir) {
            tampung_total = tampung_total + parseFloat(tampung[awal - 1]["subtotal"]);
            awal++;
        }

        setDataInputPesanan(tampung);
        setTotal(tampung_total);
    }

    const ubah_jumlah_pesanan = (event, id_produk) => {
        const re = /^[0-9\b]+$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }

        var tampung = data_input_pesanan;
        var awal = 1;
        var akhir = tampung.length;
        while (awal <= akhir) {
            if (tampung[awal - 1]["id_produk"] === id_produk) {
                tampung[awal - 1]["jumlah"] = event.target.value;
                tampung[awal - 1]["subtotal"] = parseInt(tampung[awal - 1]["jumlah"]) * parseInt(tampung[awal - 1]["harga"]);
                tampung[awal - 1]["subtotal2"] = format_rupiah(tampung[awal - 1]["subtotal"]);
                break;
            }
            awal++;
        }

        var tampung_total = 0;
        awal = 1;
        akhir = tampung.length;
        while (awal <= akhir) {
            tampung_total = tampung_total + parseFloat(tampung[awal - 1]["subtotal"]);
            awal++;
        }

        setDataInputPesanan(tampung);
        setTotal(tampung_total);
    }

    const perbaiki_pesanan = (event, id_produk, jumlah_minimal) => {
        var tampung = data_input_pesanan;
        var awal = 1;
        var akhir = tampung.length;
        while (awal <= akhir) {
            if (tampung[awal - 1]["id_produk"] === id_produk) {
                if (parseFloat(event.target.value) > 0) {
                    if (parseInt(event.target.value) < parseInt(jumlah_minimal)) {
                        tampung[awal - 1]["jumlah"] = jumlah_minimal;
                    }
                    else {
                        tampung[awal - 1]["jumlah"] = event.target.value;
                    }
                }
                else {
                    tampung[awal - 1]["jumlah"] = jumlah_minimal;
                }
                tampung[awal - 1]["subtotal"] = tampung[awal - 1]["jumlah"] * tampung[awal - 1]["harga"];
                tampung[awal - 1]["subtotal2"] = format_rupiah(tampung[awal - 1]["subtotal"]);
                break;
            }
            awal++;
        }

        var tampung_total = 0;
        awal = 1;
        akhir = tampung.length;
        while (awal <= akhir) {
            tampung_total = tampung_total + parseFloat(tampung[awal - 1]["subtotal"]);
            awal++;
        }

        setDataInputPesanan(tampung);
        setTotal(tampung_total);
    }

    const hapus_pesanan = (id_produk) => {
        var tampung = data_input_pesanan;
        var awal = 1;
        var akhir = tampung.length;
        while (awal <= akhir) {
            if (tampung[awal - 1]["id_produk"] === id_produk) {
                delete tampung[awal - 1];
                break;
            }
            awal++;
        }

        tampung = tampung.filter(function (element) {
            return element !== undefined;
        });

        var tampung_total = 0;
        awal = 1;
        akhir = tampung.length;
        while (awal <= akhir) {
            tampung[awal - 1]["no"] = awal;
            tampung_total = tampung_total + parseFloat(tampung[awal - 1]["subtotal"]);
            awal++;
        }

        setDataInputPesanan(tampung);
        setTotal(tampung_total);
    }

    const ubah_jumlah_bayar = (event) => {
        const re = /^[0-9\b]+$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }
        setJumlahBayar(event.target.value);
        setKembalian(parseInt(event.target.value) + parseInt(jumlah_bayar2) + parseInt(diskon) + parseInt(dp) - parseInt(total));
    }

    const perbaiki_jumlah_bayar = (event) => {
        if (parseFloat(event.target.value) > 0) {
            setJumlahBayar(event.target.value);
            setKembalian(parseInt(event.target.value) + parseInt(jumlah_bayar2) + parseInt(diskon) + parseInt(dp) - parseInt(total));
        }
        else {
            setJumlahBayar(0);
            setKembalian(parseInt(0) + parseInt(jumlah_bayar2) + parseInt(diskon) + parseInt(dp) - parseInt(total));
        }
    }

    const ubah_jumlah_bayar2 = (event) => {
        const re = /^[0-9\b]+$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }
        setJumlahBayar2(event.target.value);
        setKembalian(parseInt(jumlah_bayar) + parseInt(event.target.value) + parseInt(diskon) + parseInt(dp) - parseInt(total));
    }

    const perbaiki_jumlah_bayar2 = (event) => {
        if (parseFloat(event.target.value) > 0) {
            setJumlahBayar2(event.target.value);
            setKembalian(parseInt(jumlah_bayar) + parseInt(event.target.value) + parseInt(diskon) + parseInt(dp) - parseInt(total));
        }
        else {
            setJumlahBayar2(0);
            setKembalian(parseInt(jumlah_bayar) + parseInt(0) + parseInt(diskon) + parseInt(dp) - parseInt(total));
        }
    }

    const ubah_diskon = (event) => {
        const re = /^[0-9\b]+$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }
        setDiskon(event.target.value);
        setKembalian(parseInt(jumlah_bayar) + parseInt(jumlah_bayar2) + parseInt(event.target.value) + parseInt(dp) - parseInt(total));
    }

    const perbaiki_diskon = (event) => {
        if (parseFloat(event.target.value) > 0) {
            setDiskon(event.target.value);
            setKembalian(parseInt(jumlah_bayar) + parseInt(jumlah_bayar2) + parseInt(event.target.value) + parseInt(dp) - parseInt(total));
        }
        else {
            setDiskon(0);
            setKembalian(parseInt(jumlah_bayar) + parseInt(jumlah_bayar2) + parseInt(0) + parseInt(dp) - parseInt(total));
        }
    }

    const ubah_diskon_persen = (event) => {
        const re = /^[+-]?\d*(?:[.]\d*)?$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }
        setDiskonPersen(event.target.value);
        setDiskon(parseInt((event.target.value / 100) * parseInt(total)));
        setKembalian(parseInt(jumlah_bayar) + parseInt(jumlah_bayar2) + parseInt((event.target.value / 100) * parseInt(total)) + parseInt(dp) - parseInt(total));
    }

    const perbaiki_diskon_persen = (event) => {
        if (event.target.value.trim() === "") {
            setDiskonPersen(0);
        }
    }

    const simpan = () => {
        if (parseFloat(hutang_awal) - parseFloat(angsuran) === 0) {
            setJenisNotif("warning");
            setIsiNotif("Hutang sudah dilunasi");
            setTampilNotif(true);
            return;
        }

        if (metode_bayar.trim() === "") {
            setJenisNotif("warning");
            setIsiNotif("Metode bayar wajib diisi");
            setTampilNotif(true);
            document.getElementById("metode_bayar").focus();
            return;
        }

        if (metode_bayar.trim() === "M0") {
            setJenisNotif("warning");
            setIsiNotif("Metode bayar ini tidak dapat digunakan");
            setTampilNotif(true);
            document.getElementById("metode_bayar").focus();
            return;
        }

        if (parseInt(jumlah_bayar) === 0) {
            setJenisNotif("warning");
            setIsiNotif("Jumlah bayar wajib diisi");
            setTampilNotif(true);
            document.getElementById("jumlah_bayar").focus();
            return;
        }

        let tampung_jumlah_bayar = 0;
        if (jumlah_bayar > parseFloat(hutang_awal) - parseFloat(angsuran)){
            tampung_jumlah_bayar = parseFloat(hutang_awal) - parseFloat(angsuran);
        }
        else{
            tampung_jumlah_bayar = jumlah_bayar;
        }

        fetch(props.aplikasi + '/kasir/simpan_piutang.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_pembayaran: id_pembayaran,
                        id_metode_bayar: metode_bayar,
                        jumlah_bayar: tampung_jumlah_bayar,
                        id_pengguna: localStorage.getItem("id_pengguna")
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {                         
                    if (jumlah_bayar >= parseFloat(hutang_awal) - parseFloat(angsuran)){
                        setAngsuran(hutang_awal);
                    }
                    else{
                        tampil_pesanan();  
                    }

                    fetch(props.aplikasi + '/kasir/tampil_angsuran.php',
                        {
                            method: 'POST',
                            body: JSON.stringify
                                ({
                                    id_pembayaran: id_pembayaran
                                }),
                            headers:
                            {
                                "Content-type": "application/json; charset=UTF-8"
                            }
                        })
                        .then(response => response.json())
                        .then(data => {
                            if (data.kode === 1) {
                                setDataAngsuran(data.data);
                            }
                            else {
                                setDataAngsuran([]);
                            }
                        })
                        .catch(error => {
                            setDataAngsuran([]);
                        }
                        );

                    setTampilDialogBayar(false);
                    setTampilDialog(true);
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
                else {
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                }
            })
            .catch(error => {
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
            }
            );
    }

    return (
        <div>
            <Snackbar
                open={tampil_notif}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={tutup_notif}
            >
                <Alert
                    severity={jenis_notif}
                    variant="filled"
                    onClose={tutup_notif}
                    sx={{ width: '100%' }}
                >
                    {isi_notif}
                </Alert>
            </Snackbar>

            <Box
                sx={{
                    backgroundColor: "#eff0f0",
                    width: "100%",
                    height: "100%"
                }}
            >
                <Grid container spacing={1} sx={{ padding: "10px" }}>
                    {data_pesanan.map((data_pesanan) => {
                        return (
                            <Grid
                                item xs={6} sm={4} md={3} lg={2}
                                key={data_pesanan.id_pembayaran}
                                onClick={() => {
                                    setIdPembayaran(data_pesanan.id_pembayaran);
                                    setNama(data_pesanan.nama_booking);
                                    setWaktuPembayaran(data_pesanan.waktu_pembayaran);
                                    setHutangAwal(data_pesanan.hutang_awal);
                                    setAngsuran(data_pesanan.angsuran);
                                    setKasir(data_pesanan.kasir);
                                    setPelayan(data_pesanan.pelayan);
                                    fetch(props.aplikasi + '/kasir/tampil_angsuran.php',
                                        {
                                            method: 'POST',
                                            body: JSON.stringify
                                                ({
                                                    id_pembayaran: data_pesanan.id_pembayaran
                                                }),
                                            headers:
                                            {
                                                "Content-type": "application/json; charset=UTF-8"
                                            }
                                        })
                                        .then(response => response.json())
                                        .then(data => {
                                            if (data.kode === 1) {
                                                setDataAngsuran(data.data);
                                            }
                                            else {
                                                setDataAngsuran([]);
                                            }
                                        })
                                        .catch(error => {
                                            setDataAngsuran([]);
                                        }
                                        );

                                    setTampilDialog(true);
                                }}
                            >
                                <Card sx={{ backgroundColor: "#66615b", color: "white" }}>
                                    <List>
                                        <ListItem button>
                                            <ListItemText
                                                primary={<Typography noWrap variant="subtitle1">{data_pesanan.nama_booking}</Typography>}
                                                secondary={<Typography noWrap variant="body2">Rp. {format_rupiah(parseFloat(data_pesanan.hutang_awal) - parseFloat(data_pesanan.angsuran))}</Typography>}
                                            >
                                            </ListItemText>
                                        </ListItem>
                                    </List>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>

            <Dialog
                fullScreen
                open={tampil_dialog}
            >
                <Box>
                    <AppBar
                        sx={{
                            display: 'flex'
                        }}
                    >
                        <Toolbar
                            sx={{ backgroundColor: "#fe9400" }}
                        >
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={() => setTampilDialog(false)}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                Piutang
                            </Typography>
                            <Button autoFocus color="inherit"
                                onClick={() => {
                                    setJumlahBayar(0);
                                    setKembalian(0);
                                    setTampilDialogBayar(true)
                                }}
                            >
                                Bayar
                            </Button>
                        </Toolbar>
                    </AppBar>

                    <Box sx={{ marginTop: "64px", padding: "10px" }}>
                        {/* <Grid container spacing={1}>
                            <Grid item xs={12} md={6} lg={5}> */}
                        <Card sx={{ padding: "10px" }}>
                            <Typography variant="h6">
                                Data Pembayaran
                            </Typography>
                            <Divider />
                            <br />

                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        No. Bukti
                                    </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography variant="body2">
                                        {id_pembayaran}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        Nama
                                    </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography variant="body2">
                                        {nama}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        Waktu Pembelian
                                    </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography variant="body2">
                                        {waktu_pembayaran}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        Kasir
                                    </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography variant="body2">
                                        {kasir}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        Pelayan
                                    </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography variant="body2">
                                        {pelayan}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        Hutang Awal
                                    </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography variant="body2">
                                        Rp. {format_rupiah(parseFloat(hutang_awal))}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        Sudah Diangsur
                                    </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography variant="body2">
                                        Rp. {format_rupiah(parseFloat(angsuran))}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        Sisa Hutang
                                    </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography variant="body2">
                                        Rp. {format_rupiah(parseFloat(hutang_awal) - parseFloat(angsuran))}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        Metode Bayar
                                    </Typography>
                                </Grid>

                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>

                                <Grid container item spacing={1} xs={9}>
                                    <Grid item xs={6}>
                                        <FormControl size="small" fullWidth>
                                            <Select
                                                id="metode_bayar"
                                                variant="outlined"
                                                fullWidth
                                                disabled={dp > 0 ? true : false}
                                                value={metode_bayar}
                                                onChange={(event) => {
                                                    if (jumlah_metode_bayar === 2) {
                                                        if (event.target.value === metode_bayar2) {
                                                            setJenisNotif("warning");
                                                            setIsiNotif("Metode bayar harus berbeda");
                                                            setTampilNotif(true);
                                                            return;
                                                        }

                                                        var awal = 1;
                                                        var akhir = data_metode_bayar.length;
                                                        while (awal <= akhir) {
                                                            if (data_metode_bayar[awal - 1]["id_metode"] === event.target.value) {
                                                                if (parseFloat(data_metode_bayar[awal - 1]["tambah_hpp"]) > 0 || parseFloat(data_metode_bayar[awal - 1]["tambah_jual"]) > 0) {
                                                                    setJenisNotif("warning");
                                                                    setIsiNotif("Tidak dapat menambah metode bayar karena terdapat metode bayar dengan penambahan nilai jual");
                                                                    setTampilNotif(true);
                                                                    return;
                                                                }
                                                                break;
                                                            }
                                                            awal++;
                                                        }
                                                    }

                                                    awal = 1;
                                                    akhir = data_metode_bayar.length;
                                                    while (awal <= akhir) {
                                                        if (event.target.value === data_metode_bayar[awal - 1].id_metode) {
                                                            setTambahJual(data_metode_bayar[awal - 1].tambah_jual);
                                                            break;
                                                        }
                                                        awal++;
                                                    }

                                                    setMetodeBayar(event.target.value);
                                                }}
                                            >
                                                {data_metode_bayar.map((data_metode_bayar) => {
                                                    return (
                                                        <MenuItem key={data_metode_bayar.id_metode} value={data_metode_bayar.id_metode}>{data_metode_bayar.nama}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Card>

                        <Card sx={{ padding: "10px" }}>
                            <Typography variant="h6">
                                Riwayat Angsuran
                            </Typography>
                            <Divider />
                            <br />

                            <TableContainer component={Paper}>
                                <Table stickyHeader size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell align="center">Tanggal</StyledTableCell>
                                            <StyledTableCell align="center">Metode Bayar</StyledTableCell>
                                            <StyledTableCell align="center">Kasir</StyledTableCell>
                                            <StyledTableCell align="center">Jumlah</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data_angsuran.map((tampung) => {
                                            return (
                                                <StyledTableRow key={tampung.id_angsuran}>
                                                    <TableCell size="small" align="center"><Typography variant="body2" noWrap={true}>{tampung.waktu_angsuran}</Typography></TableCell>
                                                    <TableCell size="small"><Typography variant="body2" noWrap={true}>{tampung.metode_bayar}</Typography></TableCell>
                                                    <TableCell size="small"><Typography variant="body2" noWrap={true}>{tampung.kasir}</Typography></TableCell>
                                                    <TableCell size="small" align="right"><Typography variant="body2" noWrap={true}>{format_rupiah(parseFloat(tampung.jumlah_bayar))}</Typography></TableCell>
                                                </StyledTableRow>
                                            );
                                        })}

                                        <TableRow>
                                            <TableCell align="right" colSpan={3}>
                                                <Typography variant="h6">
                                                    Total
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right"><Typography variant="h6" noWrap={true} sx={{ color: "red" }}>{format_rupiah(parseFloat(angsuran))}</Typography></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Card>
                    </Box>
                </Box>
            </Dialog>

            <Dialog
                open={tampil_dialog_bayar}
            >
                <DialogTitle>Pembayaran</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Grid container item spacing={1}>
                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>

                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" align="right">
                                            Tagihan
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="h4" align="right" sx={{ color: "red" }}>
                                            Rp. {format_rupiah(parseFloat(hutang_awal) - parseFloat(angsuran))}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>
                                    <Typography variant="body2">
                                        Jumlah Bayar
                                    </Typography>
                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <TextField
                                            id="jumlah_bayar"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            multiline
                                            disabled={metode_bayar === "M0" ? true : false}
                                            value={jumlah_bayar}
                                            onChange={(e) => ubah_jumlah_bayar(e)}
                                            onBlur={(e) => perbaiki_jumlah_bayar(e)}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="h6" align="right" sx={{ color: "green" }}>
                                            Rp. {format_rupiah(parseInt(jumlah_bayar))}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>

                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" align="right">
                                            Kembalian
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="h6" align="right" sx={{ color: "red" }}>
                                            Rp. {format_rupiah(parseFloat(jumlah_bayar) - (parseFloat(hutang_awal) - parseFloat(angsuran)))}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<PrintIcon />}
                        sx={
                            id_bayar !== ""
                                ? { marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "#8080FF" }
                                : { display: "none" }
                        }
                        onClick={() =>
                            window.open(props.aplikasi + '/kasir/cetak_pembayaran.php?id_bayar=' + id_bayar)
                        }
                    >
                        Cetak
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<AttachMoneyIcon />}
                        sx={
                            id_bayar === ""
                                ? { marginRight: "5px", marginTop: "5px", borderRadius: "5em" }
                                : { display: "none" }
                        }
                        onClick={() => simpan()}
                    >
                        Bayar
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<CloseIcon />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "#555555" }}
                        onClick={() => {
                            // if (id_bayar !== "") {
                            //     setIdBayar("");
                            //     setJumlahBayar(0);
                            //     setJumlahBayar2(0);
                            //     setMetodeDiskon("nominal");
                            //     setDiskonPersen(0);
                            //     setDiskon(0);
                            //     setTampilDialog(false);
                            //     tampil_pesanan();
                            // }
                            setTampilDialogBayar(false);
                        }}
                    >
                        Tutup
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                fullScreen
                open={tampil_dialog_produk}
            >
                <Box sx={{ height: "calc(100% - 90px)" }}>
                    <AppBar
                        sx={{
                            display: 'flex'
                        }}
                    >
                        <Toolbar
                            sx={{ backgroundColor: "#fe9400" }}
                        >
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={() => setTampilDialogProduk(false)}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                Pilih Menu
                            </Typography>
                        </Toolbar>
                    </AppBar>

                    <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: "64px" }}>
                        <Tabs
                            centered
                            value={jenis}
                            onChange={(event, value) => ubah_jenis_produk(value)}
                        >
                            {data_jenis.map((data_jenis) => {
                                return (
                                    <Tab key={data_jenis.id_jenis} value={data_jenis.id_jenis} label={data_jenis.nama} />
                                )
                            })}
                        </Tabs>
                    </Box>

                    <Box>
                        <Grid container spacing={1} sx={{ padding: "10px" }}>
                            {/* <Grid container item spacing={1} xs={12} lg={7}>
                                {data_produk.map((data_produk) => {
                                    return (
                                        <Grid
                                            key={data_produk.id_produk}
                                            sx={{ margin: "10px", width: "150px" }}
                                            onClick={() => {
                                                var tampung = [];
                                                var awal, akhir = 0;
                                                if (data_input_pesanan.length > 0) {
                                                    tampung = data_input_pesanan;
                                                    awal = 1;
                                                    akhir = tampung.length;
                                                    var cari = "";
                                                    while (awal <= akhir) {
                                                        if (tampung[awal - 1]["id_produk"] === data_produk.id_produk) {
                                                            tampung[awal - 1]["jumlah"] = parseInt(tampung[awal - 1]["jumlah"]) + 1;
                                                            tampung[awal - 1]["subtotal"] = parseInt(tampung[awal - 1]["jumlah"]) * parseInt(tampung[awal - 1]["harga"]);
                                                            tampung[awal - 1]["subtotal2"] = format_rupiah(tampung[awal - 1]["subtotal"]);
                                                            cari = "ada";
                                                            break;
                                                        }
                                                        awal++;
                                                    }

                                                    if (cari === "") {
                                                        tampung.push({ "id_jenis": data_produk.id_jenis, "jenis": data_produk.jenis, "id_produk": data_produk.id_produk, "nama": data_produk.nama, "hpp": data_produk.hpp, "jumlah": 1, "harga": data_produk.harga, "harga2": data_produk.harga2, "subtotal": data_produk.harga, "subtotal2": data_produk.harga2, "tambahan": "1" });
                                                    }
                                                }
                                                else {
                                                    tampung.push({ "id_jenis": data_produk.id_jenis, "jenis": data_produk.jenis, "id_produk": data_produk.id_produk, "nama": data_produk.nama, "hpp": data_produk.hpp, "jumlah": 1, "harga": data_produk.harga, "harga2": data_produk.harga2, "subtotal": data_produk.harga, "subtotal2": data_produk.harga2, "tambahan": "1" });
                                                }

                                                var total = 0;
                                                awal = 1;
                                                akhir = tampung.length;
                                                while (awal <= akhir) {
                                                    total = total + parseFloat(tampung[awal - 1]["subtotal"]);
                                                    awal++;
                                                }

                                                setDataInputPesanan(tampung);
                                                setTotal(total);
                                            }}
                                        >
                                            <Card>
                                                <ImageListItem>
                                                    <CardMedia
                                                        component="img"
                                                        src={props.file + "/Foto/Produk/" + data_produk.foto}
                                                        sx={{
                                                            backgroundColor: "gray",
                                                            width: "150px",
                                                            height: "150px"
                                                        }}
                                                    />
                                                    <ImageListItemBar
                                                        title={data_produk.nama}
                                                        subtitle={"Rp. " + data_produk.harga2}
                                                    />
                                                </ImageListItem>
                                            </Card>
                                        </Grid>
                                    );
                                })}
                            </Grid> */}

                            <Grid item xs={12} md={5}>
                                <Card sx={{ padding: "10px" }}>
                                    <Typography variant="h6">
                                        Daftar Pesanan
                                    </Typography>
                                    <Divider />
                                    <br />

                                    <TableContainer component={Paper}>
                                        <Table stickyHeader size="small" aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell align="center">Nama</StyledTableCell>
                                                    <StyledTableCell align="center">Harga</StyledTableCell>
                                                    <StyledTableCell align="center">Jumlah</StyledTableCell>
                                                    <StyledTableCell align="center">Subtotal</StyledTableCell>
                                                    <StyledTableCell align="center">Aksi</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {data_input_pesanan.map((data_input_pesanan) => {
                                                    return (
                                                        <StyledTableRow key={data_input_pesanan.id_produk}>
                                                            <TableCell size="small"><Typography variant="body2" noWrap={true}>{data_input_pesanan.nama}</Typography></TableCell>
                                                            <TableCell size="small" align="right"><Typography variant="body2" noWrap={true}>{data_input_pesanan.harga2}</Typography></TableCell>
                                                            <TableCell size="small" align="center" sx={{ whiteSpace: "nowrap" }}>
                                                                <Fab
                                                                    color="primary"
                                                                    size="small"
                                                                    style={{ backgroundColor: "gray" }}
                                                                    onClick={() => kurang_pesanan(data_input_pesanan.id_produk, data_input_pesanan.jumlah_minimal)}
                                                                >
                                                                    <RemoveIcon />
                                                                </Fab>
                                                                <TextField
                                                                    variant="outlined"
                                                                    size="small"
                                                                    inputProps={{
                                                                        style: { textAlign: "center", width: "50px" }
                                                                    }}
                                                                    value={data_input_pesanan.jumlah}
                                                                    onChange={(e) => ubah_jumlah_pesanan(e, data_input_pesanan.id_produk)}
                                                                    onBlur={(e) => perbaiki_pesanan(e, data_input_pesanan.id_produk, data_input_pesanan.jumlah_minimal)}
                                                                />
                                                                <Fab
                                                                    color="primary"
                                                                    size="small"
                                                                    style={{ backgroundColor: "gray" }}
                                                                    onClick={() => tambah_pesanan(data_input_pesanan.id_produk)}
                                                                >
                                                                    <AddIcon />
                                                                </Fab>
                                                            </TableCell>
                                                            <TableCell size="small" align="right"><Typography variant="body2" noWrap={true}>{data_input_pesanan.subtotal2}</Typography></TableCell>
                                                            <TableCell size="small" align="center">
                                                                <Fab
                                                                    color="primary"
                                                                    size="small"
                                                                    style={data_input_pesanan.tambahan === "1" ? { backgroundColor: "red" } : { display: "none" }}
                                                                    onClick={() => hapus_pesanan(data_input_pesanan.id_produk)}
                                                                >
                                                                    <DeleteIcon />
                                                                </Fab>
                                                            </TableCell>
                                                        </StyledTableRow>
                                                    );
                                                })}

                                                <TableRow>
                                                    <TableCell align="right" colSpan={3}>
                                                        <Typography variant="h6">
                                                            Total
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell align="right"><Typography variant="h6" noWrap={true} sx={{ color: "red" }}>{format_rupiah(total)}</Typography></TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={7}>
                                <Grid container>
                                    <Grid container>
                                        <TextField
                                            id="input-with-icon-textfield"
                                            label="Cari berdasarkan nama produk (tekan Enter)"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            sx={{ margin: "10px" }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <SearchOutlined
                                                            onClick={() => cari()}
                                                        />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            value={pencarian}
                                            onChange={(event) => setPencarian(event.target.value)}
                                            onKeyPress={(event) => {
                                                if (event.key === "Enter") {
                                                    cari();
                                                }
                                            }}
                                        />
                                    </Grid>

                                    <Grid
                                        item xs={12}
                                    >
                                        <Stack spacing={2}>
                                            <Pagination
                                                color="primary"
                                                count={jumlah_halaman}
                                                page={halaman}
                                                onChange={(event, nomor) => {
                                                    pindah_halaman(nomor);
                                                }}
                                            />
                                        </Stack>
                                    </Grid>

                                    <Grid container spacing={1}>
                                        {data_produk.map((data_produk) => {
                                            return (
                                                <Grid
                                                    key={data_produk.id_produk}
                                                    sx={{ margin: "10px", width: "150px" }}
                                                    onClick={() => {
                                                        var tampung = [];
                                                        var awal, akhir = 0;
                                                        if (data_input_pesanan.length > 0) {
                                                            tampung = data_input_pesanan;
                                                            awal = 1;
                                                            akhir = tampung.length;
                                                            var cari = "";
                                                            while (awal <= akhir) {
                                                                if (tampung[awal - 1]["id_produk"] === data_produk.id_produk) {
                                                                    tampung[awal - 1]["jumlah"] = parseInt(tampung[awal - 1]["jumlah"]) + 1;
                                                                    tampung[awal - 1]["subtotal"] = parseInt(tampung[awal - 1]["jumlah"]) * parseInt(tampung[awal - 1]["harga"]);
                                                                    tampung[awal - 1]["subtotal2"] = format_rupiah(tampung[awal - 1]["subtotal"]);
                                                                    cari = "ada";
                                                                    break;
                                                                }
                                                                awal++;
                                                            }

                                                            if (cari === "") {
                                                                tampung.push({ "id_jenis": data_produk.id_jenis, "jenis": data_produk.jenis, "id_produk": data_produk.id_produk, "nama": data_produk.nama, "hpp": data_produk.hpp, "jumlah": 1, "harga": data_produk.harga, "harga2": data_produk.harga2, "subtotal": data_produk.harga, "subtotal2": data_produk.harga2, "tambahan": "1" });
                                                            }
                                                        }
                                                        else {
                                                            tampung.push({ "id_jenis": data_produk.id_jenis, "jenis": data_produk.jenis, "id_produk": data_produk.id_produk, "nama": data_produk.nama, "hpp": data_produk.hpp, "jumlah": 1, "harga": data_produk.harga, "harga2": data_produk.harga2, "subtotal": data_produk.harga, "subtotal2": data_produk.harga2, "tambahan": "1" });
                                                        }

                                                        var total = 0;
                                                        awal = 1;
                                                        akhir = tampung.length;
                                                        while (awal <= akhir) {
                                                            total = total + parseFloat(tampung[awal - 1]["subtotal"]);
                                                            awal++;
                                                        }

                                                        setDataInputPesanan(tampung);
                                                        setTotal(total);
                                                    }}
                                                >
                                                    <Card>
                                                        <ImageListItem>
                                                            <CardMedia
                                                                component="img"
                                                                src={props.file + "/Foto/Produk/" + data_produk.foto}
                                                                sx={{
                                                                    backgroundColor: "gray",
                                                                    width: "150px",
                                                                    height: "150px"
                                                                }}
                                                            />
                                                            <ImageListItemBar
                                                                title={data_produk.nama}
                                                                subtitle={"Rp. " + data_produk.harga2}
                                                            />
                                                        </ImageListItem>
                                                    </Card>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>

                                    <Grid
                                        item xs={12}
                                    >
                                        <Stack spacing={2}>
                                            <Pagination
                                                color="primary"
                                                count={jumlah_halaman}
                                                page={halaman}
                                                onChange={(event, nomor) => {
                                                    pindah_halaman(nomor);
                                                }}
                                            />
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Dialog>
        </div>
    );
}

export default forwardRef(Piutang);